import {useCallback, useEffect, useRef} from 'react';

const useOutsideClick = (ref: ReturnType<typeof useRef<HTMLElement>>, callback: () => void) => {
  const handleClick = useCallback(
    e => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    },
    [callback],
  );

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
};

export default useOutsideClick;
